import React, { Fragment } from 'react';
import LoadingBlueOrange from '../../../../../components/shared/icons/LoadingBlueOrange';
import { MainContainer } from '../../resume/RequestResume';
import {
  DocumentosColetaError,
  DocumentosColetaHeader,
  DocumentosColetaImage,
  DocumentosColetaLoading,
  DocumentosColetaMeta,
  DocumentosColetaMissing,
  DocumentosColetaPage,
  DocumentosColetaPretendenteBlock,
  DocumentosColetaPretendenteNome,
  DocumentosColetaSection,
  DocumentosColetaTipoDocumento,
  DocumentosColetaTipoPretendente,
  DocumentosColetaTitle,
} from './laudoDocumentosColeta.styles';

export const filterDocumentosColetaSecoes = (payload, pretendenteId = null) => {
  if (!payload || !Array.isArray(payload.secoes)) {
    return null;
  }

  if (!pretendenteId) {
    return payload;
  }

  const secoes = payload.secoes.filter(
    (secao) => Number(secao.pretendente_id) === Number(pretendenteId),
  );

  if (secoes.length === 0) {
    return null;
  }

  return {
    ...payload,
    titulo: 'Documentos LucIA COLETA — Pretendente',
    secoes,
  };
};

const LaudoDocumentosColetaSection = ({
  payload,
  loading = false,
  error = null,
  solicitationId,
}) => {
  if (!loading && !error && (!payload || !Array.isArray(payload.secoes) || payload.secoes.length === 0)) {
    return null;
  }

  let sectionContent = null;

  if (loading) {
    sectionContent = (
      <DocumentosColetaSection aria-busy="true">
        <DocumentosColetaLoading>
          <LoadingBlueOrange width="20px" />
          <span style={{ marginLeft: 8 }}>Carregando documentos da coleta…</span>
        </DocumentosColetaLoading>
      </DocumentosColetaSection>
    );
  } else if (error) {
    sectionContent = (
      <DocumentosColetaSection>
        <DocumentosColetaError>{error}</DocumentosColetaError>
      </DocumentosColetaSection>
    );
  } else {
    sectionContent = (
      <DocumentosColetaSection className="laudo-documentos-coleta">
        <DocumentosColetaTitle>{payload.titulo || 'Documentos LucIA COLETA'}</DocumentosColetaTitle>

        {payload.secoes.map((secao, secaoIndex) => (
          <DocumentosColetaPretendenteBlock key={`${secao.pretendente_id || 'orphan'}-${secaoIndex}`}>
            {(secao.documentos || []).map((documento, docIndex) => (
              <Fragment key={`${documento.tipo || docIndex}-${docIndex}`}>
                {(documento.paginas || []).length === 0 ? (
                  <DocumentosColetaPage>
                    <DocumentosColetaHeader>
                      <DocumentosColetaMeta>
                        Solicitação #{solicitationId}
                      </DocumentosColetaMeta>
                      <DocumentosColetaPretendenteNome>
                        {secao.pretendente_nome}
                      </DocumentosColetaPretendenteNome>
                      <DocumentosColetaTipoPretendente>
                        {secao.tipo_pretendente}
                      </DocumentosColetaTipoPretendente>
                      <DocumentosColetaTipoDocumento>
                        {documento.tipo_label}
                      </DocumentosColetaTipoDocumento>
                    </DocumentosColetaHeader>
                    <DocumentosColetaMissing>
                      Documento indisponível para visualização.
                    </DocumentosColetaMissing>
                  </DocumentosColetaPage>
                ) : (
                  (documento.paginas || []).map((pagina, paginaIndex) => (
                    <DocumentosColetaPage key={`${documento.tipo}-page-${paginaIndex}`}>
                      <DocumentosColetaHeader>
                        <DocumentosColetaMeta>
                          Solicitação #{solicitationId}
                        </DocumentosColetaMeta>
                        <DocumentosColetaPretendenteNome>
                          {secao.pretendente_nome}
                        </DocumentosColetaPretendenteNome>
                        <DocumentosColetaTipoPretendente>
                          {secao.tipo_pretendente}
                        </DocumentosColetaTipoPretendente>
                        <DocumentosColetaTipoDocumento>
                          {documento.tipo_label}
                        </DocumentosColetaTipoDocumento>
                      </DocumentosColetaHeader>
                      <DocumentosColetaImage
                        src={pagina.url}
                        alt={documento.tipo_label}
                        loading="lazy"
                      />
                    </DocumentosColetaPage>
                  ))
                )}
              </Fragment>
            ))}
          </DocumentosColetaPretendenteBlock>
        ))}
      </DocumentosColetaSection>
    );
  }

  return <MainContainer>{sectionContent}</MainContainer>;
};

export default LaudoDocumentosColetaSection;
